import {
  Box,
  Container,
  Heading,
  Stack,
  Text,
  Divider,
} from "@chakra-ui/react";

import { Breadcrumb } from "#app/components/index.jsx";

export const Layout = ({ children, ...props }) => {
  return (
    <Container
      as="section"
      mx="auto"
      px={{
        base: "6",
        md: "8",
      }}
      {...props}
    >
      <Breadcrumb mb={4} />
      {children}
    </Container>
  );
};

export const Header = ({
  title,
  titleProps = {},
  subtitle,
  subtitleProps = {},
  action = null,
  hasDivider = false,
  ...props
}) => (
  <>
    <Stack
      spacing={{ base: "4", md: "4" }}
      direction={{ base: "column", md: "row" }}
      justify="space-between"
      {...props}
    >
      <Box w="100%">
        {typeof title === "function" ? (
          title({
            as: "h1",
            size: "xs",
            fontWeight: "bold",
            letterSpacing: "tight",
          })
        ) : (
          <Heading
            size="xs"
            fontWeight="bold"
            letterSpacing="tight"
            {...titleProps}
            as="h1"
          >
            {title}
          </Heading>
        )}
        {subtitle &&
          (typeof subtitle === "function" ? (
            subtitle({
              fontSize: "md",
            })
          ) : (
            <Text fontSize="md" {...subtitleProps}>
              {subtitle}
            </Text>
          ))}
      </Box>
      {action && (
        <Stack direction="row" spacing="3">
          {action}
        </Stack>
      )}
    </Stack>
    {hasDivider ? <Divider my={4} /> : <Box my={4} />}
  </>
);

export const Content = ({ children, ...props }) => {
  return <Box {...props}>{children}</Box>;
};
